module.exports = __webpack_public_path__ + "fonts/bootstrap-icons.b0dc2193.woff";